export class LabelCaseValueConverter {
  toView(value: string) {
    if (!value) return '';

    return value
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, (str) => str.toUpperCase())
      .trim();
  }
}